var render = function render(_c,_vm){return _c('div',{class:_vm.props.value ? `${_vm.data.class || ''} background-color--${_vm.props.value}` : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }